"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var matchRow = exports.matchRow = function matchRow(keyField, id) {
  return function (row) {
    return row[keyField] === id;
  };
};

var getRowByRowId = exports.getRowByRowId = function getRowByRowId(data, keyField, id) {
  return data.find(matchRow(keyField, id));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap-table-next/lib/src/store/rows.js
// module id = 168
// module chunks = 0